function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "mail_2_",
  "data-name": "mail (2)",
  transform: "translate(0 -68.267)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3050",
  "data-name": "Group 3050",
  transform: "translate(0.687 68.267)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3049",
  "data-name": "Group 3049",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_256",
  "data-name": "Path 256",
  d: "M34.921,68.267H17.067l8.927,7.353,9.028-7.333A.622.622,0,0,0,34.921,68.267Z",
  transform: "translate(-17.067 -68.267)",
  fill: "#c7c7c7"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3052",
  "data-name": "Group 3052",
  transform: "translate(0 69.48)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3051",
  "data-name": "Group 3051",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_257",
  "data-name": "Path 257",
  d: "M10.047,105.967a.687.687,0,0,1-.87,0L0,98.406v11.835a.687.687,0,0,0,.687.687H18.541a.687.687,0,0,0,.687-.687V98.508Z",
  transform: "translate(0 -98.406)",
  fill: "#c7c7c7"
}))));

var SvgMail2 = function SvgMail2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.228,
    height: 13.734,
    viewBox: "0 0 19.228 13.734",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail2.b505fac6.svg";
export { ForwardRef as ReactComponent };